import { InputNumber, Button, Text } from '@clockout-dev/design-elements';
import { DeleteOutlined } from '@ant-design/icons';
import styles from '../styles/limitsForm.module.scss';

function AdvanceCapTenureRuleRow({ rule, onUpdate, onRemove, disabled }) {
    return (
        <div className={styles.ruleRow}>
            <Text as="span" size="s" className={styles.ruleLabel}>
                if a user has a tenure of
            </Text>
            <InputNumber
                key={`fromDays-${rule.id}`}
                defaultValue={rule.fromDays}
                onChange={(value) => onUpdate(rule.id, 'fromDays', value)}
                min={0}
                max={36500}
                controls={false}
                disabled={disabled}
                placeholder="From"
                className={`${styles.inlineNumberInput} ${styles.rangeField}`}
            />
            <Text as="span" size="s" className={styles.ruleLabel}>
                to
            </Text>
            <InputNumber
                key={`toDays-${rule.id}`}
                defaultValue={rule.toDays}
                onChange={(value) => onUpdate(rule.id, 'toDays', value)}
                min={0}
                max={36500}
                controls={false}
                disabled={disabled}
                placeholder="To"
                className={`${styles.inlineNumberInput} ${styles.rangeField}`}
            />
            <Text as="span" size="s" className={styles.ruleLabel}>
                days, their advance cap will be exactly
            </Text>
            <InputNumber
                key={`value-${rule.id}`}
                defaultValue={rule.value}
                onChange={(value) => onUpdate(rule.id, 'value', value)}
                min={0}
                max={999}
                controls={false}
                disabled={disabled}
                className={`${styles.inlineNumberInput} ${styles.countField}`}
            />
            <Text as="span" size="s" className={styles.ruleLabel}>
                advances
            </Text>
            <Button
                type="button"
                size="s"
                variant="text"
                className={styles.deleteButton}
                onClick={() => onRemove(rule.id)}
                disabled={disabled}
            >
                <DeleteOutlined />
            </Button>
        </div>
    );
}

export default AdvanceCapTenureRuleRow;
